import { Wizard, WizardStep } from '@factorialco/deprecated-design-system'

import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import TemplateSettings from 'modules/documents/components/BulkFiles/_steps/templateSettings'
import useGeneratePreviewDocument from 'modules/documents/hooks/documents/useGeneratePreviewDocument'
import { Folder } from 'modules/documents/hooks/useGetFolders'

import { WizardData } from './types'

interface Props {
  onClose: () => void
  onUploadFinished: () => Promise<unknown>
  folders: Folder[]
}

const DocumentTemplateStepsModal = ({ onClose, onUploadFinished, folders }: Props) => {
  const initialData: WizardData = {
    distributionWorkflow: 'templates',
    uploadType: 'do_not_touch',
    templateId: null,
    folderId: null,
    combineFileName: '',
    extension: '',
    esignatureRequest: false,
    templateDisabled: true,
    additionalSignersAccessIds: [],
  }

  const { generatePreview, loading: isGeneringPreview } = useGeneratePreviewDocument()

  const onSubmit = async ({
    folderId,
    templateId,
    combineFileName,
    extension,
    esignatureRequest,
    additionalSignersAccessIds,
  }: WizardData) => {
    if (!templateId) return

    const result = await generatePreview({
      templateId,
      folderId,
      filename: combineFileName.split(extension)[0],
      esignatureRequest,
      additionalSignersAccessIds,
    })

    const handled = handleResult(result, (errors) => {
      const errorMessages = Object.values(errors)
      const errorMessage = errorMessages && errorMessages[0]

      if (errorMessage) app.setFlash({ type: 'wrong', message: errorMessage })
    })

    if (handled.success) {
      app.setFlash({ type: 'correct', message: i18n.t('common.documents_uploaded') })
      await onUploadFinished()
    }

    return handled
  }

  const canUploadProcess = (
    combinedFileName: string,
    templateId: string | null | undefined,
    templateDisabled?: boolean
  ): boolean => {
    return (combinedFileName && templateId && !templateDisabled && !isGeneringPreview) || false
  }

  const templateStep: WizardStep<WizardData> = {
    title: i18n.t('split_documents.upload_process.workflows.template.sidebar'),
    isCompleted: ({ combineFileName, templateId, templateDisabled }) =>
      canUploadProcess(combineFileName, templateId, templateDisabled),
    nextText: i18n.t('split_documents.upload_process.workflows.template.submit'),
    render: (props) => <TemplateSettings {...props} folders={folders} />,
  }

  return (
    <Wizard.Modal
      title={i18n.t('split_documents.upload_process.workflows.template.title')}
      icon="template"
      initialData={initialData}
      onSubmit={onSubmit}
      onClose={onClose}
      steps={[templateStep]}
    />
  )
}

export default DocumentTemplateStepsModal
